<template>
  <div class="container" @scroll="handleScroll">
    <app-header :title="title" :is-back="isBack" @back="back"/>
    <div class="test">
      <van-search v-model="value" @click="$router.push('/search')" placeholder="请输入搜索关键词" />
      <!-- 分类 -->
      <div  style="overflow: hidden">
        <div class="tabs row">
          <div class="tab" v-text="item.name" v-for="(item,index) in tabList" :key="index" :class="[item.id == tab?'active':'']" @click="handleTag(item,index)"></div>
        </div>
      </div>
      <Category :cateList="twoChild" :tab="tab" v-if="twoChild.length > 0"/>

      <!-- 推荐商品 -->
      <Goods :productList="productList" :tab="tab"/>
    </div>
  </div>
</template>

<script>
import Goods from './modules/Goods'
import Category from './modules/Category'
import { getShopCategoryList } from '@/api/category'
import { getCategoryProductList } from '@/api/product'
export default {
  name: 'Index',
  components: {
    Goods,
    Category
  },
  data() {
    return {
      title : '集成电路',
      value: '',
      isBack: false,
      activeTag: 0,
      tab: 0,
      productList: [],
      tabList: [],
      twoChild: []
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log('1111',from)
      console.log(vm)
      if (from.name == 'homeCategory' || from.name == 'productDetail') {
        vm.tab = Number(from.params.tab)
      }
      if(from.name == 'home' || from.name == 'homeCategory') {
        vm.id = vm.$route.query.id
        vm.title = vm.$route.query.name
        vm.activeTag = vm.$route.query.activeTag
        vm.tab = vm.$route.query.tab
        vm.getTab(vm.id);
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    to.meta.keepAlive = true // 给列表(list.vue)页面设置keepAlive
    localStorage.setItem("scrollTop", document.documentElement.scrollTop)
    if(to.name != 'productDetail') {
      this.productList = []
      this.tabList = []
      this.twoChild = []
    }
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = localStorage.getItem("scrollTop")
      localStorage.setItem("scrollTop", 0)
    })
  },
  created() {

  },
  watch: {
    '$route': function(val) {
      console.log('44444444444444444444444444444444444',val)
      // if(val.query && val.query.id && val.name == 'homeTop') {
      //   this.id = this.$route.query.id
      //   this.title = this.$route.query.name
      //   this.activeTag = this.$route.query.activeTag
      //   this.tab = this.$route.query.tab
      //   this.getTab(this.id);
      // } else {
      //
      // }
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.title = this.$route.query.name
    this.activeTag = this.$route.query.activeTag
    this.tab = this.$route.query.tab
    this.getTab(this.id);
  },
  methods: {
    handleScroll(val) {
      console.log(val)
    },
    back(){
      //this.$router.push({path: '/home'})
      this.$router.go(-1)
    },
    getTab(pid) {
      getShopCategoryList({ pid: pid }).then(res => {
        if (res.success) {
          this.tabList = res.data
          if (this.tabList.length > 0) {
            let pid = this.tabList[0].id
            if (!this.tab){
              this.tab = pid
              this.getSonTab(pid)
            }else{
              this.getSonTab(this.tab)
            }
            this.getProduct(this.tab)
          }
        }
      })
    },
    getSonTab(pid) {
      getShopCategoryList({ pid: pid }).then(res => {
        if (res.success) {
          this.twoChild = res.data
        }
      })
    },
    getProduct(cid) {
      getCategoryProductList({ parentId: cid }).then(res => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate(url) {
      this.$router.push({
        path: url
      })
    },
    handleTag(item,index) {
      this.tab = item.id
      this.activeTag = item.id
      let pid = this.tabList[index].id
      this.getSonTab(pid)
      this.getProduct(this.activeTag)
    },
    gotoSearchProduct() {
      if (!this.value) {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .van-nav-bar__left img {
    width: 25px;
    height: 25px;
  }
  .container{

    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      line-height: 44px;
      padding: 0 12px;
      overflow-x: scroll;
      -webkit-backface-visibility: hidden;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      .tab {
        height:25px;
        line-height: 25px;
        padding: 0 0.4rem;
        white-space: nowrap;
        font-size: 16px;
        font-weight:bold;
        cursor: pointer;
        &.active {
          color: #FE003B;
          border-bottom: 3px solid #FE003B;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/home_top.vue